import { create } from 'zustand'
import { SHOW_MOCK_OFFSETS } from '@/config/app'

const MIN_TOP_OFFSET = 45
const MIN_BOTTOM_OFFSET = 30
const MOCK_TOP_OFFSET = 100
const MOCK_BOTTOM_OFFSET = 50

export const getInitialOffsets = () => {
  if (SHOW_MOCK_OFFSETS) {
    return {
      top: MOCK_TOP_OFFSET,
      bottom: MOCK_BOTTOM_OFFSET,
      left: 0,
      right: 0,
    }
  }

  // Fallback values before SDK initialization
  const fallbackOffsets = {
    top: MIN_TOP_OFFSET,
    bottom: MIN_BOTTOM_OFFSET,
    left: 0,
    right: 0,
  }
  return fallbackOffsets
}

interface LayoutState {
  offsets: {
    top: number
    bottom: number
    left: number
    right: number
  }
  setOffsets: (offsets: LayoutState['offsets']) => void
  isAndroid: boolean
  setIsAndroid: (isAndroid: boolean) => void
  screenBackground: string | null
  setScreenBackground: (color: string | null) => void
}

const useLayoutStore = create<LayoutState>((set) => ({
  offsets: getInitialOffsets(),
  setOffsets: (offsets) => set({ offsets }),
  isAndroid: false,
  setIsAndroid: (isAndroid) => set({ isAndroid }),
  screenBackground: null,
  setScreenBackground: (screenBackground) => set({ screenBackground }),
}))

export default useLayoutStore
